module.exports = __webpack_public_path__ + "static/media/Best seller promotion 3.a5de1dbe.jpg";